import React from 'react';
import classNames from 'classnames';
import $ from '../../../offline/jquery.min.js';
import './style.scss';

import ModalSkipDynamicForm from './ModalSkipDynamicForm';
import ModalWorkOrderSelector from './ModalWorkOrderSelector';
import ModalClear from './ModalClear';
import LfaHeader from './LfaHeader';
import Spin from '../Common/Spin';
import Button from '../Common/Button';
import LfaCustomForm from './LfaCustomForm';
import LfaForm from './LfaForm';
import Tabs from '../Common/Tabs';
import WorkOrderForm from '../Common/WorkOrderForm';
import Icon from '../Common/Icon';
import { ReactComponent as PrintIcon } from '../../../img/icon-print.svg';

import ActionItemsService from '../../Services/api/ActionItems';
import DynamicFormDataService from '../../Services/api/DynamicFormData';
import UnitsService from '../../Services/api/Units';
import DynamicFormService from '../../Services/api/DynamicForm';
import Utils from '../../Services/Utils';
import History from '../../Services/History';
import NotificationService from '../../Services/NotificationService';
import ConfigService from '../../Services/api/Config';
import DFFWorkOrderService from '../../Services/DFFWorkOrderService';
import { checkTriggerCondition, getConditionLabel } from '../../Services/ConditionalService';

import FormContextProvider, { FormContext } from '../../Context/FormContext';
import LfaContext, { LfaContextProvider } from '../../Context/LfaContext';
import WorkOrderContextProvider from '../../Context/WorkOrderContext';
import Radio from '../FormFields/Radio/index.js';
import InputText from '../FormFields/Text';
import { ReactComponent as CaretIcon } from '../../../img/caret.svg';
import { ReactComponent as CaretDownIcon } from '../../../img/caret-down.svg';
import { ReactComponent as CloseIcon } from '../../../img/close-icon.svg';

// eslint-disable-next-line no-duplicate-imports
import { STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER } from '../../Services/api/ActionItems';

class _DynamicFormScreen extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalSkipVisible: false,
      modalWorkOrderVisible: false,
      modalWorkOrderConfig: null,
      modalWorkOrderData: null,
      modalClear: false,
      stats: null,
      print: this.props.data.print,
      actionItemStatus: this.props.data.status,
      approvalStatus: this.props.data.approvalStatus,
      workOrderTabs: [],
      saving: false,
      lastAutoSave: null,
      created_in_language: this.props.data.preferred_language ? this.props.data.preferred_language : 'en',
      lastAutoSave: null, 
      searchableValue: [],
      currentIndex: -1, 
      showResult: false, 
      keywordSearch: '', 
      oldSearchValue: '',
      availableLanguages: this.props.availableLanguages
    };

    this.fields = {};
    this.Form = React.createRef();
  }

  UNSAFE_componentWillMount() {
    const { data, configTheme } = this.props;
    this.context.api.init({...data, created_in_language : this.state.created_in_language}, this.state.availableLanguages);
    ConfigService.updateConfig(configTheme);
  }

  componentDidMount() {
    const { data } = this.props;
    History.singleton().register(
      'modalClear',
      () => {
        this.onPressedClear();
      },
      () => {
        this.onPressedModalClearClose();
      }
    );
    History.singleton().register(
      'modalSkip',
      () => {
        this.onPressedSkip();
      },
      () => {
        this.onPressedModalSkipClose();
      }
    );
    History.singleton().register(
      'modalWorkOrder',
      () => {
        this.onPressedWorkOrder();
      },
      () => {
        this.onModalWorkOrderClose();
      }
    );
    if ([STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER].includes(data.status) && !data.force) {
      this.interval = setInterval(() => {
        this.autoSave();
      }, 60000);
    }
    this.context.api.replicateSaveProgress(this.saveProgress);
  }

  componentWillUnmount() {
    History.singleton().unregister('modalClear');
    History.singleton().unregister('modalSkip');
    History.singleton().unregister('modalWorkOrder');
    clearInterval(this.interval);
  }

  onPressedClear = () => {
    History.singleton().show('modalClear');
    this.setState({ modalClear: true });
  };

  onPressedModalClearClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalClear: false });
  };

  onPressedSkip = () => {
    History.singleton().show('modalSkip');
    this.setState({ modalSkipVisible: true });
  };

  onPressedModalSkipClose = (event) => {
    History.singleton().close(event);
    this.setState({ modalSkipVisible: false });
  };

  onPressedWorkOrder = (field, data) => {
    if (field.disabled) {
      return;
    }
    History.singleton().show('modalWorkOrder');
    this.setState({
      modalWorkOrderVisible: true,
      modalWorkOrderConfig: field,
      modalWorkOrderData: data
    });
  };

  onModalWorkOrderClose = (event) => {
    History.singleton().close(event);
    this.setState({
      modalWorkOrderVisible: false,
      modalWorkOrderConfig: null,
      modalWorkOrderData: null
    });
  };

  onReopen = async () => {
    const { task, unit, filters } = this.context;
    await ActionItemsService.reopen(task, filters);
    await this.getNewContextData(unit.id, true);
  };

  clear = () => {
    const { data } = this.props;
    const { status, api } = this.context;
    const { dfData } = data;
    const dataErrors = api.getErrors();
    data.dfData = { ...dfData, data: null, score: null, errors: dataErrors };
    data.status = status;
    api.clearData(data);
  };

  validateForm = (skipResolve) => {
    const { fieldsData, api, workOrderTabs, configuration } = this.context;
    const error = api.getFirstError();
    if (error && error.id && !error.collapsed) {
      return false;
    } else if (error && error.id) {
      if (!skipResolve) {
        api.onSectionCollapsed(false, error.sectionId);
      }
      return false;
    }
    let invalid = null;
    let required = null;
    const workOderFields = Object.values(workOrderTabs);
    Object.keys(fieldsData.sections).forEach((section) => {
      const sectionData = fieldsData.sections[section];
      Object.keys(sectionData.fields).forEach((field) => {
        const fieldData = sectionData.fields[field];
        const fieldConfig = configuration.sections.items[section].fields.items[field];
        const { triggers } = fieldConfig;
        if (triggers) {
          triggers.forEach((trigger) => {
            const triggerCondition = checkTriggerCondition(trigger, fieldConfig, fieldData.value);
            const workOrders =
              fieldData.workOrderTriggers && fieldData.workOrderTriggers[trigger.id] ? fieldData.workOrderTriggers[trigger.id].work_orders : null;
            if (triggerCondition) {
              if (trigger.workOrderRequired && isEmpty(workOrders)) {
                required = { field: fieldConfig, data: fieldData };
                return required;
              } else if (!isEmpty(workOrders)) {
                workOrders.forEach((item) => {
                  if (!item.valid) {
                    invalid = { field: fieldConfig, data: fieldData };
                  }
                  return invalid;
                });
              }
            }
          });
        }
        return { required, invalid };
      });
      return { required, invalid };
    });
    if (workOderFields.length > 0 || invalid || required) {
      if (required && !skipResolve) {
        NotificationService.notify('error', 'There are required Work Order Triggers pending  before completing the task.');
        this.onPressedWorkOrder(required.field, required.data);
      } else if (invalid && !skipResolve) {
        NotificationService.notify('error', 'Please validate or delete all pending Work Orders Triggers before completing the task.');
        this.onPressedWorkOrder(invalid.field, invalid.data);
      } else if (!skipResolve) {
        NotificationService.notify('error', 'Please validate or delete all pending Work Orders Triggers before completing the task.');
        const triggersIndexArray = Object.keys(workOderFields[0]).map((item) => item);
        const workOrderNumber = workOderFields[0][triggersIndexArray[0]].length <= 1 ? '' : `(1)`;
        const { section, id } = api.getFieldData(workOderFields[0][triggersIndexArray[0]][0].groupId);
        const field = configuration.sections.items[section].fields.items[id];
        const conditionLabel = getConditionLabel(field, triggersIndexArray[0]);
        const tabLabel = `Work Order for ${workOderFields[0][triggersIndexArray[0]][0].label}: ${conditionLabel} ${workOrderNumber}`;
        api.onSetTab(tabLabel);
      }
      return false;
    }
    return true;
  };

  autoSave = async () => {
    const { fieldsData, api, modified, filters } = this.context;
    const { data } = this.props;
    const { stats, saving, lastAutoSave, approvalStatus } = this.state;
    if (saving || !modified || (lastAutoSave && modified < lastAutoSave)) {
      return null;
    }
    const validate = this.validateForm(true);
    this.setState({
      saving: true,
      lastAutoSave: new Date()
    });
    const dataSaga = await api.convertToSaga(true);
    if (stats) {
      dataSaga.time_spent = stats.time_spent.current;
    }
    dataSaga.valid = validate;
    dataSaga.in_progress = approvalStatus ? !validate : true;
    if (data.force) {
      dataSaga.force = true;
    }
    let response = null;
    if (fieldsData && fieldsData.id) {
      response = await DynamicFormDataService.update(fieldsData.id, dataSaga, filters, true);
    } else {
      response = await DynamicFormDataService.create(dataSaga, filters, true);
    }
    if (response) {
      const triggers = await api.saveDFChargeCodes(response.id, true);
      if (!Utils.isEmpty(triggers)) {
        response = await DynamicFormDataService.update(response.id, dataSaga, filters, true);
      }
      if (response) {
        api.setData({ ...fieldsData, id: response.id });
      }
    }
    this.setState({
      saving: false
    });
    return response;
  };

  saveProgress = async (close, type) => {
    const { fieldsData, api, task, unit, filters } = this.context;
    const { data } = this.props;
    const { stats, saving, actionItemStatus, approvalStatus } = this.state;
    if (saving) {
      return null;
    }
    const validate = this.validateForm(true);
    this.setState({
      saving: true,
      lastAutoSave: new Date()
    });
    const dataSaga = await api.convertToSaga();
    if (stats) {
      dataSaga.time_spent = stats.time_spent.current;
    }
    dataSaga.valid = validate;
    dataSaga.in_progress = approvalStatus ? !validate : true;
    if (data.force) {
      dataSaga.force = true;
    }
    let response = null;
    if (fieldsData && fieldsData.id) {
      response = await DynamicFormDataService.update(fieldsData.id, dataSaga, filters);
    } else {
      response = await DynamicFormDataService.create(dataSaga, filters);
    }
    if (response) {
      const triggers = await api.saveDFChargeCodes(response.id);
      if (!Utils.isEmpty(triggers)) {
        response = await DynamicFormDataService.update(response.id, dataSaga, filters);
      }
      if (response) {
        api.setData({...fieldsData, id: response.id});
      }
    }
    this.setState({
      saving: false
    });
    if (!response) {
      return null;
    }
    if (close) {
      return this.props.submissionCallback('close');
    }
    data.dfData = {
      ...data.dfData,
      data: dataSaga.data,
      errors: dataSaga.errors,
      dynamic_form_fields: response.dynamic_form_fields,
      id: response.id,
      trigger_data: response.trigger_data
    };
    data.task = task;
    data.unit = unit;
    data.status = actionItemStatus;
    if(type === 'workOrder'){
      await api.init({...data, created_in_language : this.state.created_in_language}, this.state.availableLanguages, this.context.workOrderTabs);
    }else{
      await api.init({...data, created_in_language : this.state.created_in_language}, this.state.availableLanguages);
    }
    return response;
  };

  onPressedFinish = async (preventCallBack) => {
    const { fieldsData, api, task, filters } = this.context;
    const { stats, saving } = this.state;
    if (saving) {
      return null;
    }
    const validate = this.validateForm();
    if (!validate) {
      return null;
    }
    this.setState({
      saving: true,
      lastAutoSave: new Date()
    });
    const dataSaga = await api.convertToSaga();
    if (stats) {
      dataSaga.time_spent = stats.time_spent.current;
    }
    dataSaga.valid = validate;
    dataSaga.in_progress = false;
    let response = null;
    if (fieldsData && fieldsData.id) {
      response = await DynamicFormDataService.update(fieldsData.id, dataSaga, filters);
    } else {
      response = await DynamicFormDataService.create(dataSaga, filters);
    }
    if (response) {
      const triggers = await api.saveDFChargeCodes(response.id);
      if (!Utils.isEmpty(triggers)) {
        response = await DynamicFormDataService.update(response.id, dataSaga, filters);
      }
    }
    this.setState({
      saving: false
    });
    if (!response) {
      return null;
    }
    if (!preventCallBack) {
      this.props.submissionCallback('finish', response, task);
      clearInterval(this.interval);
    }
    return response;
  };

  onPressedClose = async () => {
    this.props.submissionCallback('close');
  };

  getNewContextData = async (unit, preventSave) => {
    const { property, api, filters } = this.context;
    const { data } = this.props;
    const { user, template } = data;
    clearInterval(this.interval);
    if (!preventSave) {
      const response = await this.saveProgress();
      if (!response) {
        return false;
      }
    }
    const actionItem = await ActionItemsService.getWorkflow(template, unit, filters);
    const unitItem = await UnitsService.get(unit, filters);
    let initData = {
      unit: unitItem,
      property,
      task: actionItem.id,
      user,
      status: actionItem.status
    };
    if (actionItem.dynamic_form_data && actionItem.dynamic_form_data !== 'skip') {
      const dataID = actionItem.dynamic_form_data.id ? actionItem.dynamic_form_data.id : actionItem.dynamic_form_data;
      const dfData = await DynamicFormDataService.get(dataID, filters);
      initData = {
        ...initData,
        df: dfData.dynamic_form,
        dfData
      };
    } else {
      const df = await DynamicFormService.get(actionItem.dynamic_form, filters);
      initData = {
        ...initData,
        df,
        dfData: null
      };
    }
    this.setState({ actionItemStatus: actionItem.status });
    await api.init({...initData, created_in_language : this.state.created_in_language}, this.state.availableLanguages);
    if ([STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER].includes(actionItem.status) && !data.force) {
      this.interval = setInterval(() => {
        this.autoSave();
      }, 60000);
    }
    return true;
  };

  onFieldAdded = (key, ref) => {
    this.fields[key] = ref;
  };

  onPrint = (elementId) => {
    this.context.api.setLoading(true);
    const content = document.getElementById(elementId);
    let pri;
    if (document.getElementById('ifmcontentstoprint')) {
      pri = document.getElementById('ifmcontentstoprint').contentWindow;
    } else {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('title', 'ifmcontentstoprint');
      iframe.setAttribute('id', 'ifmcontentstoprint');
      iframe.setAttribute('style', 'height: 0px; width: 0px; position: absolute;');
      document.body.appendChild(iframe);
      pri = iframe.contentWindow;
    }
    pri.document.open();
    pri.document.write('<html><head><title></title><body>' + content.innerHTML + '</body></html>');
    pri.document.close();
    $('link[rel="stylesheet"]').each(function () {
      const cssLink = document.createElement('link');
      cssLink.href = $(this).attr('href');
      cssLink.rel = 'stylesheet';
      cssLink.type = 'text/css';
      pri.document.head.appendChild(cssLink);
    });
    $('style').each(function () {
      const cssStyle = document.createElement('style');
      cssStyle.innerText = this.innerText;
      pri.document.head.appendChild(cssStyle);
    });
    setTimeout(() => {
      pri.focus();
      pri.print();
      this.context.api.setLoading(false);
    }, 1000);
  };

  onPressFinishButton = (context) => {
    context.submit(this.onPressedFinish, this.context.api.getFirstError());
  };

  onClickSaveWorkOrder = async (workOrderData) => {
    const { fieldsData, api } = this.context;
    const { data } = this.props;

    // Get trigger_data updated for validate form correctly on SaveProgress
    const dfData = await DynamicFormDataService.get(fieldsData.id);
    const dataSaga = await api.convertToSaga();
    data.dfData = {
      ...data.dfData,
      data: dataSaga.data,
      errors: dataSaga.errors,
      trigger_data: dfData.trigger_data
    };
    await api.init({...data, created_in_language : this.state.created_in_language}, this.state.availableLanguages);

    await this.saveProgress();
    this.onClickCancelWorkOrder(workOrderData);
  };

  onClickSetTab = (tab) => {
    this.context.api.onSetTab(tab);
  };

  onClickCancelWorkOrder = (workOrderData, activeTab) => {
    this.context.api.onCloseWorkOrderTab(workOrderData, activeTab);
  };

  onSetWorkOrderFormData = (dataObj, workOrderData) => {
    this.context.api.onSetWorkOrderFormData(dataObj, workOrderData);
  };

  onPressWorkOrder = (triggerId) => {
    const { api } = this.context;
    const { modalWorkOrderConfig } = this.state;
    if (modalWorkOrderConfig.disabled) {
      return;
    }
    if (triggerId) {
      const { groupId, label } = modalWorkOrderConfig;
      const workOrderTabData = { groupId, label, triggerId };
      api.onClickCreateNewWorkOrderTab(workOrderTabData);
    } else {
      this.onPressedWorkOrder();
    }
  };

  onEditWorkOrder = (triggerId, index) => {
    const { api } = this.context;
    const { modalWorkOrderConfig, modalWorkOrderData } = this.state;
    if (modalWorkOrderConfig.disabled) {
      return;
    }
    const { disabled, groupId, label } = modalWorkOrderConfig;
    if (disabled) {
      return;
    }
    const { workOrderTriggers } = modalWorkOrderData;
    if (workOrderTriggers && workOrderTriggers[triggerId]) {
      const work_orders = workOrderTriggers[triggerId].work_orders;
      const workOrderTabData = work_orders[index];
      api.onClickEditNewWorkOrderTab(workOrderTabData, groupId, triggerId, label);
    }
  };

  onDeleteWorkOrder = async (triggerId, index) => {
    const { api } = this.context;
    const { modalWorkOrderConfig, modalWorkOrderData } = this.state;
    const { disabled, groupId } = modalWorkOrderConfig;
    if (disabled) {
      return;
    }
    const { workOrderTriggers } = modalWorkOrderData;
    if (workOrderTriggers[triggerId].work_orders[index]) {
      await api.onClickDeleteNewWorkOrderTab(index, groupId, triggerId);
      const deletedWorkOrderTriggers = { ...workOrderTriggers };
      deletedWorkOrderTriggers[triggerId].work_orders.splice(index, 1);
      this.setState({
        modalWorkOrderData: {
          ...modalWorkOrderData,
          workOrderTriggers: deletedWorkOrderTriggers
        }
      });
      DFFWorkOrderService.setWorkOrder(api, modalWorkOrderConfig, deletedWorkOrderTriggers);
      await this.saveProgress();
    }
  };

  renderButton = (text, fn, className = '', display = true) => {
    return <Button display={display} className={`Button_Small ${className}`} onClick={() => fn()} btnText={text} />;
  };

  updateCompleteInLanguage = (lang) => {
      const { api } = this.context;
      this.setState({created_in_language : lang});
      api.onCompleteInLanguage(lang);
  }

  clearSearch = (fromClear) =>{
    Array.from(document.querySelectorAll('.highlighted_text')).forEach(
      (el) => el.classList.remove('highlighted_text')
    );
    if(fromClear){
      this.setState({keywordSearch: '', oldSearchValue: ''});
    }
    this.setState({currentIndex : -1, searchableValue: [], showResult: false});
  }

  onChangeSearchValue = (value) =>{
    // for updating the state keywordSearch
    this.setState({keywordSearch: value});
  }

  getMatchResults = (value) =>{
    let matchResult = [];
    let elements = document.querySelectorAll (".Widget_Label_Text, .Widget_Label_Description, .InputRadio_Label, .WrapperSection_Label, .InputCheckbox_Label, .InputRadio_Label, .InputCheckbox_Label, .InputText, .FormDesription_Label");
    for (var i = 0; i < elements.length; i++) {
      // skip the element if it has keyword search class and it is input element
      if((elements[i].tagName == 'INPUT') && (elements[i].placeholder == 'Keyword Search')) {
        continue; 
      }
       var text = elements[i].tagName == 'INPUT' ? elements[i].value : elements[i].tagName == 'TEXTAREA' ? elements[i].textContent : elements[i].innerText;
       var index = text.toLowerCase().indexOf(value.toLowerCase());
       if (index != -1) {
        matchResult.push(elements[i]);
       }
    }
    return matchResult;
  }

  handleInputChange = (event) => {
    if (event.currentTarget.value && event.currentTarget.value != '' && event.currentTarget.value.trim() != '') {
      let searchableValue = this.getMatchResults(event.currentTarget.value);
      if ((event.currentTarget.value != this.state.oldSearchValue) || ((event.currentTarget.value == this.state.oldSearchValue) && (this.state.searchableValue.length != searchableValue.length))) {
        this.clearSearch();
        if (searchableValue.length > 0) {
          this.setState({ currentIndex: 0 });
          searchableValue[0].scrollIntoView({ behavior: 'smooth' });
          searchableValue[0].classList.add('highlighted_text');
        }
        this.setState({ searchableValue: searchableValue, showResult: true, oldSearchValue: this.state.keywordSearch });
      }
      else {
        this.navigateNext();
      }

    }
    else {
      this.clearSearch();
    }
  }

  navigateNext = () => {
  if (this.state.currentIndex !== -1) {
    this.state.searchableValue[this.state.currentIndex].classList.remove('highlighted_text'); // Remove the highlight from the current element
    let currentIndex = (this.state.currentIndex + 1) % this.state.searchableValue.length;
    this.setState({currentIndex : currentIndex}); // Move to the next element
    this.state.searchableValue[currentIndex].classList.add('highlighted_text'); // for highlighting the next element
    this.state.searchableValue[currentIndex].scrollIntoView(); // Scrolling to the next element
  }
}

navigatePrevious = () => {
  if (this.state.currentIndex !== -1) {
    this.state.searchableValue[this.state.currentIndex].classList.remove('highlighted_text'); // Remove the highlight from the current element
    let currentIndex = (this.state.currentIndex - 1 + this.state.searchableValue.length) % this.state.searchableValue.length;
    this.setState({currentIndex : currentIndex }) ; // Move to the previous element
    this.state.searchableValue[currentIndex].classList.add('highlighted_text'); // Highlight the previous element
    this.state.searchableValue[currentIndex].scrollIntoView(); // Scroll to the previous element
  }}

  renderDF = () => {
    const { fieldsData, fieldsError, configuration, property, unit, api, task, status, filters, loading, availableLanguages, tabs } = this.context;
    const { data } = this.props;
    const force = data ? data.force : false;

    const { modalSkipVisible, modalWorkOrderVisible, modalClear, actionItemStatus, modalWorkOrderConfig, modalWorkOrderData, print } = this.state;

    if (!configuration) {
      return false;
    }
    const scoreType = configuration.scoreType && configuration.scoreType.value ? configuration.scoreType.value : configuration.scoreType;
    const columns = configuration.columns && configuration.columns.value ? configuration.columns.value : configuration.columns;

    const action = !Utils.isNull(fieldsData.id) ? 'Edit' : 'Create';

    const formName = configuration.name ? configuration.name.toLowerCase() : '';
    const lfaAccounts = [31, 75];
    const isLFA = formName.includes('lease file audit') && lfaAccounts.includes(configuration.account);
    const previewLanguage = data ? data.previewLanguage : null;

    const statusApproval = [STATUS_APPROVAL_IN_PROGRESS].includes(data.status);
    let form_name = configuration.name;
    let form_description = configuration.description;
    if(availableLanguages && availableLanguages.length > 0){
      form_name = (configuration.preview && previewLanguage && configuration.locale[previewLanguage.code]) ? configuration.locale[previewLanguage.code].name : (configuration.created_in_language && configuration.locale[configuration.created_in_language]) ? configuration.locale[configuration.created_in_language].name : configuration.name;
      form_description = (configuration.preview && previewLanguage && configuration.locale[previewLanguage.code]) ? configuration.locale[previewLanguage.code].description : (configuration.created_in_language && configuration.locale[configuration.created_in_language]) ? configuration.locale[configuration.created_in_language].description : configuration.description;
    }
    

    const formProps = {
      configuration,
      api,
      onFieldAdded: this.onFieldAdded,
      onPressedWorkOrder: this.onPressedWorkOrder,
      fieldsData,
      fieldsError,
      status, 
      previewLanguage,
      created_in_language: this.state.created_in_language
    };
    return (
      <FormContextProvider>
        <FormContext.Consumer>
          {(context) => (
            <div
              id="WrapperForm"
              className={classNames('WrapperDynamicForm', {
                WrapperDynamicForm_LFATable: isLFA
              })}>
              {configuration.disabled && print && (
                <Icon
                  className="icon-print"
                  width="25"
                  height="25"
                  color="secondaryColor"
                  onClick={() => {
                    this.onPrint('WrapperForm');
                  }}>
                  <PrintIcon alt="print" />
                </Icon>
              )}
              {(unit && isLFA && !force && (
                <LfaHeader
                  property={property}
                  unit={unit}
                  force={force}
                  action={action}
                  handleSave={this.saveProgress}
                  api={api}
                  task={task}
                  getNewContextData={this.getNewContextData}
                  status={status}
                  dfName={form_name}
                  filters={filters}
                  handleFinish={async (preventClosing) => {
                    const finish = await context.submit(() => this.onPressedFinish(preventClosing), api.getFirstError());
                    if (finish) {
                      context.cancel();
                    }
                    return finish;
                  }}
                  handleClose={this.onPressedClose}
                  handleClear={this.onPressedClear}
                  handleUpdateStats={async (stats) => {
                    await this.setState({ stats });
                  }}
                  actionItemStatus={actionItemStatus}
                  handleReopen={this.onReopen}
                  showStatistics={configuration.workflowStatistics}
                />
              )) || (
                <div className="WrapperDynamicForm_Header Center">
                  <h2>
                    {force && (
                      <span className="Red" style={{ color: ConfigService.getColor('errorColor') }}>
                        {action}
                      </span>
                    )}
                    {form_name}
                  </h2>
                  {!isLFA && !configuration.preview &&
                    <>
                      <div className='search_main'>
                        <div className='search_parent'>
                          <InputText
                            placeholder="Keyword Search"
                            className='Input-Search'
                            notShowErrors={true}
                            onSubmit={this.handleInputChange}
                            value={this.state.keywordSearch}
                            onChange={this.onChangeSearchValue}
                          />
                        </div>
                      </div>
                      {this.state.showResult &&
                        <div className='search_main m-10'>
                          <div className='search_parent'>
                            <span className="searchBar___counter">{this.state.currentIndex + 1}/{this.state.searchableValue.length}</span>
                            <div className="searchBar___jump">
                              <Icon
                                width="20"
                                height="20"
                                onClick={this.navigatePrevious}>
                                <CaretIcon alt="previous"
                                />
                              </Icon>
                              <Icon
                                width="20"
                                height="20"
                                onClick={this.navigateNext}>
                                <CaretDownIcon alt="next" id="next" />
                              </Icon>
                              <Icon
                                width="20"
                                height="20"
                                color="black"
                                onClick={() => { this.clearSearch(true) }}>
                                <CloseIcon alt="close" />
                              </Icon>
                            </div>
                          </div>
                        </div>
                      }
                    </>
                  }
                  <h3 style={{ color: ConfigService.getColor('secondaryColor') }}>{property ? property.name : ''}</h3>
                </div>
              )}
              {
                (availableLanguages && availableLanguages.length > 0 && !configuration.preview && configuration.languages && configuration.languages.length > 0 && tabs && tabs.length > 0 ) && 
                <div className="previewFormHeader">
                  <div className='previewFormHeader_endchild'>
                  {
                  tabs.map(lang => {
                    return <Radio key = {lang.code} onChange={() => this.updateCompleteInLanguage(lang.code)} label={lang.name} checked={this.state.created_in_language == lang.code}
                    className="InputCheckbox_Block" />
                  })
                }
                    </div>
                </div>
              }
              {(isLFA && <LfaCustomForm {...formProps} />) || <LfaForm {...formProps} property={property} />}
              {scoreType > 0 && (
                <div className="WrapperDynamicForm_Score Bold Center" style={{ color: ConfigService.getColor('tertiaryColor', false, -40) }}>
                  <span>Form score:</span>
                  {fieldsData.score}
                </div>
              )}

              {!configuration.disabled && force && (
                <div
                  className={classNames('WrapperDynamicForm_Actions Center', {
                    'WrapperDynamicForm_Actions--with-columns': columns > 1
                  })}>
                  {this.renderButton('Clear', this.onPressedClear, 'Button_Delete Inline')}
                  {this.renderButton('Save Progress', () => this.saveProgress(true), 'Inline')}
                </div>
              )}
              {!configuration.disabled && (!unit || !isLFA) && !force && (
                <div
                  className={classNames('WrapperDynamicForm_Actions Center', {
                    'WrapperDynamicForm_Actions--with-columns': columns > 1
                  })}>
                  {this.renderButton('Clear', this.onPressedClear, 'Button_Delete Inline')}
                  {this.renderButton('Skip', this.onPressedSkip, 'Button_Delete Inline', !configuration.required && !statusApproval)}
                  {this.renderButton('Save Progress', () => this.saveProgress(statusApproval), 'Inline')}
                  {this.renderButton('Finish', () => this.onPressFinishButton(context), 'Inline', !statusApproval)}
                </div>
              )}
              {configuration.disabled && (!unit || !isLFA) && !configuration.preview && !force && (
                <div
                  className={classNames('WrapperDynamicForm_Actions Center', {
                    'WrapperDynamicForm_Actions--with-columns': columns > 1
                  })}>
                  {this.renderButton('Ok', this.onPressedClose, 'Inline')}
                </div>
              )}
              {modalClear && <ModalClear onClose={this.onPressedModalClearClose} onSubmit={this.clear} />}
              {modalSkipVisible && (
                <ModalSkipDynamicForm
                  name={form_description}
                  onClose={this.onPressedModalSkipClose}
                  onSubmit={() => this.props.submissionCallback('skip')}
                  data={fieldsData.id}
                />
              )}
              {modalWorkOrderVisible && (
                <ModalWorkOrderSelector
                  configuration={modalWorkOrderConfig}
                  data={modalWorkOrderData}
                  api={api}
                  onClose={this.onModalWorkOrderClose}
                  onCreateWorkOrder={(triggerId) => this.onPressWorkOrder(triggerId)}
                  onEditWorkOrder={this.onEditWorkOrder}
                  onDeleteWorkOrder={this.onDeleteWorkOrder}
                />
              )}
              {loading && <Spin />}
            </div>
          )}
        </FormContext.Consumer>
      </FormContextProvider>
    );
  };

  renderTabularScreen = (openWorkOrderTabs) => {
    const { activeTab, fieldsData, configuration, api, filters, user } = this.context;
    const { workOrderAnalyticsHandler } = this.props;
    const DF = (
      <div label={'Dynamic Form'} key={'tabDynamicForm'}>
        {this.renderDF()}
      </div>
    );
    const tabItems = [DF];

    openWorkOrderTabs.map((fieldTabs) => {
      Object.keys(fieldTabs).forEach((trigger) => {
        const oneItem = fieldTabs[trigger].length === 1;
        fieldTabs[trigger].map((tabData, index) => {
          const { label, groupId, time, triggerId } = tabData;
          const { section, id } = api.getFieldData(groupId);
          const field = configuration.sections.items[section].fields.items[id];
          const conditionLabel = getConditionLabel(field, triggerId);
          const workOrderNumber = oneItem ? '' : `(${index + 1})`;
          const tabLabel = `Work Order for ${label}: ${conditionLabel} ${workOrderNumber}`;
          const data = {
            label,
            groupId,
            time,
            triggerId
          };
          const key = `${groupId}-${triggerId}-${workOrderNumber}-work-order`;
          tabItems.push(
            <div label={tabLabel} key={key} data={data}>
              <FormContextProvider>
                <WorkOrderForm
                  data={tabData}
                  filters={filters}
                  onSaveData={this.saveProgress}
                  dynamicFormDataId={fieldsData.id}
                  onSetWorkOrderFormData={this.onSetWorkOrderFormData}
                  onClickSaveWorkOrder={this.onClickSaveWorkOrder}
                  onClickCancelWorkOrder={this.onClickCancelWorkOrder}
                  user={user}
                  workOrderAnalyticsHandler={workOrderAnalyticsHandler}
                />
              </FormContextProvider>
            </div>
          );
        });
        return tabItems;
      });
    });

    return (
      <Tabs activeTab={activeTab} onClick={this.onClickSetTab} onClickCancel={this.onClickCancelWorkOrder} api={api} configuration={configuration}>
        {tabItems}
      </Tabs>
    );
  };

  render() {
    const { workOrderTabs } = this.context;
    const workOderFields = Object.values(workOrderTabs);

    if (workOderFields.length > 0) {
      return this.renderTabularScreen(workOderFields);
    }
    return this.renderDF();
  }
}

_DynamicFormScreen.contextType = LfaContext;

class DynamicFormScreen extends React.PureComponent {
  render() {
    const { data, submissionCallback, configTheme, availableLanguages, workOrderAnalyticsHandler } = this.props;
    return (
      <LfaContextProvider>
        <WorkOrderContextProvider>
          <_DynamicFormScreen data={data} submissionCallback={submissionCallback} configTheme={configTheme} availableLanguages={availableLanguages} workOrderAnalyticsHandler={workOrderAnalyticsHandler} />
        </WorkOrderContextProvider>
      </LfaContextProvider>
    );
  }
}

window.LfaScreen = DynamicFormScreen;
export default DynamicFormScreen;
